import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { ApplicationEditLayout, Content } from "core/layouts";
import {
    BaasicFieldDropdown,
    DatePickerField
} from "core/components";

const FacilityInventoryCountEditTemplate = function({ facilityInventoryCountEditViewStore }) {
    
    const { 
        contentLoading,
		form,
		facilityStore
    } = facilityInventoryCountEditViewStore;

    return (
        <ApplicationEditLayout store={facilityInventoryCountEditViewStore}>
			<Content loading={contentLoading}>
				<React.Fragment>
					<div className="row">
						<div className="col col-sml-10 col-lrg-8">
							<div className="card card--form card--primary card--med">
								<div className="row">
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<BaasicFieldDropdown field={form.$('facilityId')} store={facilityStore} disabled={false}/>
									</div>
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<DatePickerField field={form.$('countDate')} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</React.Fragment>
			</Content>
		</ApplicationEditLayout>
    );
};

FacilityInventoryCountEditTemplate.propTypes = {
	facilityInventoryCountEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func,
};

export default defaultTemplate(FacilityInventoryCountEditTemplate);